/* global axios */
import ApiClient from '../ApiClient';

class NexceoStaffAiConversationsAPI extends ApiClient {
  constructor() {
    super('nexceo/staff_ai_conversations', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  getMessages(id) {
    return axios.get(`${this.url}/${id}/messages`);
  }

  sendMessage(id, content) {
    return axios.post(`${this.url}/${id}/send_message`, { content });
  }

  repair() {
    return axios.post(`${this.url}/repair`);
  }

  setupForMember(projectTeamMemberId) {
    return axios.post(`${this.url}/setup_for_member`, {
      project_team_member_id: projectTeamMemberId,
    });
  }
}

export default new NexceoStaffAiConversationsAPI();
